/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnLeftUp: {
  name: 'arrow-turn-left-up';
  data: string;
} = {
  name: 'arrow-turn-left-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L7.5 2.207V14a.5.5 0 0 0 .5.5h5a.5.5 0 0 1 0 1H8A1.5 1.5 0 0 1 6.5 14V2.207L3.354 5.354a.5.5 0 1 1-.708-.708l4-4Z" fill="currentColor"/></svg>`,
};
